module.exports = __webpack_public_path__ + "static/media/user_agreement.7c2596e8.htm";